import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="play-now" className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20pattern%20with%20deep%20crimson%20and%20golden%20amber%20flowing%20textures%2C%20modern%20elegant%20design%2C%20luxurious%20atmosphere%2C%20subtle%20gradient%2C%20perfect%20for%20section%20background%2C%20no%20text%2C%20smooth%20artistic%20composition&width=1920&height=600&seq=cta-mahjong-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/85 to-primary-900/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-background-50 mb-4">
          准备好开始你的麻将之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8">
          免费注册，即开即玩。数百万玩家正在线上等你来战！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/categories"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 bg-accent-500 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-accent-500/30"
          >
            免费开始游戏
          </Link>
          <Link
            to="/articles"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            学习麻将技巧
          </Link>
        </div>
      </div>
    </section>
  );
}